import React from 'react';

interface MiniCompletionPieChart {
  percentage: number; // Percentage to fill the pie chart (0-100)
  size?: number; // Size of the pie chart (default is 16)
  strokeWidth?: number; // Stroke width of the pie chart (default is 4)
  /** Colour of the unfilled track. Defaults to slate grey for tutorial chip. */
  trackStroke?: string;
}

export const MiniCompletionPieChart: React.FC<MiniCompletionPieChart> = ({
  percentage,
  size = 16,
  strokeWidth = 4,
  trackStroke = '#E2E8F0',
}) => {
  const radius = (size - strokeWidth) / 2; // The radius of the circle
  const circumference = 2 * Math.PI * radius; // Circumference of the circle
  const offset = circumference - (percentage / 100) * circumference; // Calculate stroke offset based on percentage

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer Circle (Background) */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={trackStroke}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Progress Circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#65A30D"
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`} // To make the progress start from the top
      />
    </svg>
  );
};
